import { useMutation } from "@tanstack/react-query";
import { HiverCustomFieldNewAuth, sendExceptionToSentry } from "h-commons";

const testAiPromptApi = async (payload) => {
  try {
    const { conversationId, aiPrompt } = payload;
    const response = await HiverCustomFieldNewAuth({
      url: "/api/v1/config/test-ai-prompt",
      method: "POST",
      data: {
        conversation_id: conversationId,
        ai_prompt: aiPrompt,
      },
    });
    if (response?.data) {
      return response.data;
    } else {
      throw new Error(`Unexpected response status: ${response.status}`);
    }
  } catch (error) {
    sendExceptionToSentry(error);
    throw error;
  }
};

export const useTestAiPrompt = () => {
  const mutation = useMutation({
    mutationFn: testAiPromptApi,
  });
  return mutation;
};
